var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('notifications'),(_vm.layoutName === 'default')?_c('Default',{staticClass:"layout-default"}):(_vm.layoutName === 'auth')?_c('Auth',{staticClass:"layout-auth"}):(_vm.layoutName === 'blank')?_c('Blank',{staticClass:"layout-blank"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }